/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SqsMessage } from '../../models/sqs-message';
import { SqsMessagePagedResult } from '../../models/sqs-message-paged-result';

export interface MonitorSearchSqsMessagesSearchSqsMessagesPost$Plain$Params {
  pageNumber?: number;
  pageSize?: number;
      body?: SqsMessage
}

export function monitorSearchSqsMessagesSearchSqsMessagesPost$Plain(http: HttpClient, rootUrl: string, params?: MonitorSearchSqsMessagesSearchSqsMessagesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SqsMessagePagedResult>> {
  const rb = new RequestBuilder(rootUrl, monitorSearchSqsMessagesSearchSqsMessagesPost$Plain.PATH, 'post');
  if (params) {
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SqsMessagePagedResult>;
    })
  );
}

monitorSearchSqsMessagesSearchSqsMessagesPost$Plain.PATH = '/Monitor/SearchSqsMessages/search-sqs-messages';
